var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"initial","height":"100%","width":"100%"}},[_c('div',{staticClass:"meta",style:({transform: _vm.style.metaTransform || 'translate(192px, 756px)'})},[(_vm.f0 && !_vm.style.hideTitle)?_c('div',{staticClass:"titel",style:({
      opacity: _vm.hide, 
      fontSize: _vm.style.fontSize*0.7+'px' || '35px', 
      fontFamily: _vm.style.fontFamily ? _vm.style.fontFamily + ', Josefin SemiBold' : 'Josefin SemiBold',
      color: _vm.style.color || 'white'
    }),domProps:{"innerHTML":_vm._s(_vm.f0)}}):_vm._e(),(_vm.f1 && !_vm.style.hideRights)?_c('div',{staticClass:"av",style:({
      opacity: _vm.hide, 
      fontSize: _vm.style.fontSize*0.7+'px' || '35px',
      fontFamily: _vm.style.fontFamily ? _vm.style.fontFamily + ', Josefin Sans' : 'Josefin Sans',
      color: _vm.style.color || 'white'
    }),domProps:{"innerHTML":_vm._s(_vm.f1)}}):_vm._e()]),_c('div',{staticClass:"sangplatta",class:{ active: _vm.active },style:({
    fontFamily: _vm.style.fontFamily ? _vm.style.fontFamily + ', Josefin Sans' : 'Josefin Sans',
    fontSize: _vm.style.fontSize ? _vm.style.fontSize+'px' : '50px',
    color: _vm.style.color || 'white',
    background: _vm.style.background || 'radial-gradient(black, rgba(0,0,0,0.15))', 
    bottom: _vm.style.bottom || '5%',
    left: _vm.style.left || '0%',
    right: _vm.style.right || '0%',
    height: _vm.style.height ? (15+15+_vm.style.height*2)+'px' : '150px' 
  })},[_c('div',{staticClass:"bricka",style:({ 
      transform: 'translateY('+(_vm.count*-(_vm.style.height||60))+'px)',
      height: _vm.style.height ? (15+15+_vm.style.height*2)+'px' : '150px',
      paddingLeft: _vm.style.centrera ? false : _vm.style.paddingLeft
    })},_vm._l((_vm.lines),function(line,i){return _c('div',{key:i,staticClass:"line",style:({
        opacity: (_vm.count == i || _vm.count+1 == i)*1, 
        height: _vm.style.height ? _vm.style.height+'px' : '60px',
        justifyContent: _vm.style.centrera ? 'center' : 'flex-start'  
      }),domProps:{"innerHTML":_vm._s(line)}})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }